import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import * as shelterActions from "./shelter.actions";
import { catchError, exhaustMap, map, of, retry } from "rxjs";
import { OwnerService } from "../../service/owner-logo.service";

@Injectable()
export class ShelterEffects {
  constructor(private actions: Actions,
              private ownerService: OwnerService) {
  }

  loadSheltersExtended$ = createEffect(() => {
    return this.actions.pipe(
      ofType(shelterActions.LOAD_SHELTERS_EXTENDED),
      exhaustMap(() => this.ownerService.getOwnerSheltersExtended()
        .pipe(
          map(shelters => ({
            type: shelterActions.LIST_OF_SHELTERS_EXTENDED,
            shelters
          })),
          retry(3),
          catchError(error => of({
            type: shelterActions.LIST_OF_SHELTERS_ERROR,
            errorCode: error.status,
            errorMessage: error.message
          }))
        )
      )
    );
  });
}
